import React, { FC, ReactNode } from 'react';

import assignmentsProvider from './assignments/assignmentsProvider';
import authProvider from './auth/authProvider';
import liveClassProvider from './liveClasses/liveClassesProvider';
import routeProvider from './routes/routeProvider';
import SnackbarProvider from './snackbar/snackbarProvider';
import SubjectsProvider from './subjects/subjectsProvider';
import SparkyChipProvider from './subjects/sparkyProvider';
import subscriptionProvider from './subscriptions/subscriptionsProvider';
import ThemeContextProvider from './theme/themeProvider';
import ToastProvider from './toast/toastProvider';
import UserProvider from './user/userProvider';

// Define the type for the provider components
type ProviderComponent = React.ComponentType<{ children: React.ReactNode }>;

// Import other created Providers and add them here -
const providers: ProviderComponent[] = [
  ThemeContextProvider,
  UserProvider,
  ToastProvider,
  assignmentsProvider,
  authProvider,
  liveClassProvider,
  routeProvider,
  subscriptionProvider,
  SnackbarProvider,
  SparkyChipProvider,
  SubjectsProvider,
];

const combineProviders = (
  components: ProviderComponent[],
): FC<{ children: ReactNode }> => {
  return components.reduce<FC<{ children: ReactNode }>>(
    (AccumulatedComponents, CurrentComponent) => {
      return ({ children }) => {
        return (
          <AccumulatedComponents>
            <CurrentComponent>{children}</CurrentComponent>
          </AccumulatedComponents>
        );
      };
    },
    ({ children }) => <>{children}</>,
  );
};

// Combining multiple providers to a single provider - this will be wrapped around App.tsx
export default combineProviders(providers);
